import React from 'react';
import { object, string, arrayOf, number, func } from 'prop-types';
import TileContainer from 'sections/tile-container/TileContainer';
import NoItems from './NoItems';
import Resources from '../resources/';
import ItemPagination from './ItemPagination';

export default function ListingItemsSection({
    listingItems, resources, tileContainerColumnClass, tileContainerTilesWrap, tileType,
    totalPages, currentPage, changePage, resetFilters
}) {
    let itemsResourcesWrapperClass = 'items-resources-wrapper';
    if (resources.length >= 1) {
        itemsResourcesWrapperClass += ' has-resources';
    }

    return (
        <div className="listing-items">
            <div className="listing-items-container">
                <div className={itemsResourcesWrapperClass}>
                    <div className="items-wrapper">
                        <NoItems
                            items={listingItems}
                            resetFilters={resetFilters}
                        />

                        <TileContainer
                            items={listingItems}
                            columnClass={tileContainerColumnClass}
                            tileWrap={tileContainerTilesWrap}
                            tileType={tileType}
                        />

                        <ItemPagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            changePage={changePage}
                        />
                    </div>
                    <Resources resources={resources} />
                </div>
            </div>
        </div>
    );
}

ListingItemsSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    listingItems: arrayOf(object).isRequired,
    tileContainerColumnClass: string.isRequired,
    tileContainerTilesWrap: string.isRequired,
    tileType: string.isRequired,
    resources: arrayOf(object).isRequired,
    totalPages: number.isRequired,
    currentPage: number.isRequired,
    changePage: func.isRequired,
    resetFilters: func.isRequired
    /* eslint-enable react/no-typos */
};
